import { Box } from "@mui/material";
import { styled } from "@mui/system";

const Flexbetween = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
});

export default Flexbetween;
